import React, { useContext } from "react";
import { AppearanceContext } from "./AppearanceContext";
import { AppearanceSection } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
export const AppearanceInvert = _ref => {
  let {
    inverted,
    children,
    style
  } = _ref;
  // This allows previous `inverted` use to still work. If `inverted` is true, wrap the children in an Appearance with mode="dark", but only if Appearance isn't set in the context already. Otherwise return the children as is.
  // check the context and if we are already inside of an Appearance, do not wrap again
  const localAppearanceContext = useContext(AppearanceContext);
  return inverted && (localAppearanceContext === null || localAppearanceContext === void 0 ? void 0 : localAppearanceContext.mode) !== "dark" ?
  /*#__PURE__*/
  // Remove the background that is normally set since this is used in some places for just text that could be over other background colors
  _jsx(AppearanceSection, {
    mode: "dark",
    style: {
      background: "initial",
      ...style
    },
    children: children
  }) : children;
};